export default "__VITE_ASSET__BXwnvJs0__"